module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24.097 16.584c-.706 3.63-3.885 6.304-7.66 6.304-3.483 0-6.43-2.27-7.43-5.4H5.232c1.15 8.38 11.214 12.372 17.26 7.088v2.382h4.28V16.584H24.1zM7.903 15.416c.706-3.63 3.885-6.304 7.66-6.304 3.483 0 6.43 2.27 7.43 5.4h3.777C25.62 6.13 15.557 2.14 9.51 7.422v-2.38H5.23v10.374h2.673z\" clip-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/svg/swap.svg
// module id = 1530
// module chunks = 0